import { isLayerSwitcherGroupState } from '@tmapy/config';
const getLayerFromGroup = (layerId, group) => {
    return group.reduce((acc, item) => {
        if (isLayerSwitcherGroupState(item)) {
            return acc.concat(getLayerFromGroup(layerId, item.children));
        }
        if (item.layerId === layerId) {
            acc.push(item);
        }
        return acc;
    }, []);
};
export const getLayer = (layerId, layerSwitcherState) => {
    const layers = getLayerFromGroup(layerId, layerSwitcherState.layers);
    if (layers.length > 1)
        throw new Error('Multiple layers with the same ID.');
    return layers[0];
};
//# sourceMappingURL=getLayer.js.map